export type InterviewTypeValues = 'PHONE' | 'MEETJIT' | 'IRL' | 'OTHER'; // REMOVED MEETJIT

export const interviewTypes: InterviewTypeValues[] = [
  'PHONE',
  'MEETJIT',
  'IRL',
  'OTHER',
];

enum INTERVIEW_TYPE {
  PHONE = 'Par téléphone',
  MEETJIT = 'En visio (Jitsi Meet)',
  IRL = 'En présentiel',
  OTHER = 'Autre',
}

export default INTERVIEW_TYPE;
